import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import If from "~/core/ui/If";

import { faInfinity } from "@fortawesome/pro-regular-svg-icons";

import { FEATURES } from "../../constants";

const SubscriptionCard = () => {
  return (
    <div className="w-full overflow-hidden rounded-xl border border-gray-200 bg-white shadow-md">
      <div className="flex items-center justify-between bg-gray-50 px-4 py-3">
        <h2 className="text-base font-semibold text-gray-900">Pro Plan</h2>
        <div className="text-right">
          <div className="text-xs text-light line-through">$1,000</div>
          <div className="text-lg font-bold text-dark">
            $200 <span className="text-xs text-dark">/ month</span>
          </div>
          <p className="mt-1 text-xs leading-light text-light">
            For your whole team.
            <br />
            ($0 per seat)
          </p>
        </div>
      </div>
      <div className="p-4">
        <ul className="space-y-2">
          {FEATURES.map((feature, idx) => (
            <li key={idx} className="flex items-start">
              <span className="mr-2 mt-0.5 text-green-500">
                <FontAwesomeIcon
                  icon={feature.icon}
                  className="h-4 w-4 shadow-sm shadow-green-200"
                />
              </span>
              <div className="flex items-start gap-1 text-sm text-black opacity-80">
                <If condition={feature.unlimited}>
                  <FontAwesomeIcon
                    icon={faInfinity}
                    className="mt-0.5 h-3.5 w-3.5"
                  />
                </If>
                <span>{feature.label}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SubscriptionCard;
